<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents no_height">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <suggest-write-component :suggestType="'updateSuggest'"
                                             :suggestKey="suggestKey"></suggest-write-component>
                </div>
                <div class="content_btn_wrap text_center">
                    <el-button type="primary" @click="submitForm()">저장</el-button>
                    <el-button type="info" @click="$router.back()">취소</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SuggestWriteComponent from "@/components/suggest/SuggestWriteComponent";
import EventBus from "@/mixins/event-bus";

export default {
    name: "SuggestWordDetail",
    components: {SuggestWriteComponent},
    inject: [],
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
            suggestKey: this.$route.params.idx,
        };
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        submitForm() {
            EventBus.$emit('writeSuggest');
        },
    },
    watch: {}
}
</script>

<style scoped>

</style>